import "./PhoneButton.css";
import { Phone } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { SxProps, Theme } from '@mui/material/styles';

interface PhoneButtonProps {
  phone: string;
  phoneFontSize?: string | number;
  phoneIconScale?: string | number;
  iconTextGap?: string | number;
  sx?: SxProps<Theme>;
}

const PhoneButton: React.FC<PhoneButtonProps> = ({
  phone,
  phoneFontSize = '19px',
  phoneIconScale = '2.0',
  iconTextGap = '15px',
  sx,
}) => {
  return (
    <Button
      className='phone-button'
      href={`tel:${phone}`}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ gap: iconTextGap, ...sx }}
    >
      <Box className='phone-icon'>
        <Phone
          sx={{
            transform: `scale(${phoneIconScale})`,
            color: 'var(--color-palette-4)',
          }}
        />
      </Box>
      <Box className='phone-text' sx={{ fontSize: phoneFontSize }}>
        +1 (613)-822-1040
      </Box>
    </Button>
  );
};

export default PhoneButton;